module.exports = __webpack_public_path__ + "7e47e7a91989323bc9861641df78141d.png";